var map = {
	"./icon--arrow-left.svg": "./wp-content/themes/class/resources/images/icons/icon--arrow-left.svg",
	"./icon--arrow-right.svg": "./wp-content/themes/class/resources/images/icons/icon--arrow-right.svg",
	"./icon--check.svg": "./wp-content/themes/class/resources/images/icons/icon--check.svg",
	"./icon--chevron-down.svg": "./wp-content/themes/class/resources/images/icons/icon--chevron-down.svg",
	"./icon--cross.svg": "./wp-content/themes/class/resources/images/icons/icon--cross.svg",
	"./icon--download.svg": "./wp-content/themes/class/resources/images/icons/icon--download.svg",
	"./icon--menu-burger.svg": "./wp-content/themes/class/resources/images/icons/icon--menu-burger.svg",
	"./icon--menu-close.svg": "./wp-content/themes/class/resources/images/icons/icon--menu-close.svg",
	"./icon--minus.svg": "./wp-content/themes/class/resources/images/icons/icon--minus.svg",
	"./icon--phone.svg": "./wp-content/themes/class/resources/images/icons/icon--phone.svg",
	"./icon--plus.svg": "./wp-content/themes/class/resources/images/icons/icon--plus.svg",
	"./path--person-details.svg": "./wp-content/themes/class/resources/images/icons/path--person-details.svg",
	"./path--person-headshot.svg": "./wp-content/themes/class/resources/images/icons/path--person-headshot.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./wp-content/themes/class/resources/images/icons sync recursive \\.svg$";